import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.assign";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component, Fragment } from "react";
import { reaction } from "mobx";
import { observer } from "mobx-react";
import FormulaPopover from "./FormulaPopover";
import FormulaForm from "./FormulaForm";
import NameTooltip from "./NameTooltip";

var InlineFormula = function (_Component) {
  _inherits(InlineFormula, _Component);

  function InlineFormula(props) {
    _classCallCheck(this, InlineFormula);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      hovered: false
    };

    _this.handleSave = function (value, newName, newFormatter) {
      var _this$props$node = _this.props.node,
          name = _this$props$node.name,
          formatter = _this$props$node.formatter,
          setValue = _this$props$node.setValue,
          setName = _this$props$node.setName,
          setFormatter = _this$props$node.setFormatter,
          toggleEditing = _this$props$node.toggleEditing;

      if (name !== newName) {
        setName(newName);
      }

      if (formatter !== newFormatter) {
        setFormatter(newFormatter);
      }

      setValue(value);
      toggleEditing(false);
    };

    _this.handleClose = function () {
      _this.props.node.toggleEditing(false);
    };

    _this.setEditing = function () {
      var toggleEditing = _this.props.node.toggleEditing;
      toggleEditing();
    };

    _this.destroy = function () {
      var destroy = _this.props.node.destroy;
      destroy();
    };

    _this.toggleHover = function () {
      var hovered = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !_this.state.hovered;

      _this.setState({
        hovered: hovered
      });
    };

    _this.handleClickFormatting = function (e, _ref) {
      var formatter = _ref.formatter;
      var setFormatter = _this.props.node.setFormatter;
      setFormatter(formatter);
    };

    _this.handleMouseEnter = function () {
      _this.toggleHover(true);
    };

    _this.handleMouseLeave = function () {
      _this.toggleHover(false);
    };

    _this.handleKeyUp = function (e) {
      if (e.which === 9 && !_this.props.node.isEditing) {
        e.preventDefault();
        e.stopPropagation();

        _this.setEditing();
      }
    };

    _this.handleRootRef = function (el) {
      return _this.rootRef = el;
    };

    _this.handleFormulaRef = function (el) {
      return _this.formulaRef = el;
    };

    if (_this.props.onSnapshot) {
      _this.onSnapshotDisposer = _this.props.node.onSnapshot(_this.props.onSnapshot);
    }

    _this.isEditingReactionDisposer = reaction(function () {
      return _this.props.node.isEditing;
    }, function (isEditing) {
      if (!isEditing) {
        _this.formulaRef.focus();
      }
    });
    return _this;
  }

  InlineFormula.prototype.componentDidMount = function componentDidMount() {
    // Preloading monaco editor - it fetches resources from CDN
    // like service worker. Calling it here prevents loading
    // state in formula input when formula popover opens
    this.props.node.store.initMonacoEditor();
  };

  InlineFormula.prototype.componentWillUnmount = function componentWillUnmount() {
    this.onSnapshotDisposer && this.onSnapshotDisposer();
    this.isEditingReactionDisposer();
  };

  InlineFormula.prototype.render = function render() {
    var _this2 = this;

    var hovered = this.state.hovered;

    var _props = this.props,
        node = _props.node,
        _props$readOnly = _props.readOnly,
        readOnly = _props$readOnly === undefined ? node.store.readOnly : _props$readOnly,
        _props$formulaFormRen = _props.formulaFormRenderer,
        formulaFormRenderer = _props$formulaFormRen === undefined ? function (props) {
      return React.createElement(FormulaForm, props);
    } : _props$formulaFormRen,
        popoverAnchorEl = _props.popoverAnchorEl,
        popoverPlacement = _props.popoverPlacement,
        style = _props.style,
        _props$container = _props.container,
        container = _props$container === undefined ? document : _props$container,
        props = _objectWithoutProperties(_props, ["node", "readOnly", "formulaFormRenderer", "popoverAnchorEl", "popoverPlacement", "style", "container"]);

    var name = node.name,
        isEditing = node.isEditing,
        formatted = node.formatted,
        store = node.store;
    var tooltipVisible = !isEditing && (hovered || store.isSomeNodeEditing);
    return React.createElement("span", _extends({
      ref: this.handleRootRef,
      style: _extends({
        position: "relative"
      }, style)
    }, props), React.createElement(Fragment, null, React.createElement(NameTooltip, {
      title: name,
      open: tooltipVisible
    }, React.createElement("span", {
      onClick: this.setEditing,
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave,
      onKeyUp: this.handleKeyUp,
      tabIndex: 0,
      ref: this.handleFormulaRef,
      className: "rxp-formula",
      style: _extends({
        cursor: "pointer",
        padding: "2px 3px",
        border: "1px solid rgb(28, 1, 255)",
        borderRadius: 4
      }, (isEditing || tooltipVisible) && {
        backgroundColor: "#E5E2FF"
      })
    }, formatted === "" ? "##" : formatted)), React.createElement(FormulaPopover, {
      anchorEl: popoverAnchorEl || this.formulaRef,
      open: !readOnly && isEditing,
      container: container.body,
      placement: popoverPlacement,
      renderChildren: function renderChildren() {
        return formulaFormRenderer(_extends({}, node.serialize(), {
          onSave: _this2.handleSave,
          onClose: _this2.handleClose,
          store: store
        }));
      }
    })));
  };

  return InlineFormula;
}(Component);

export default observer(InlineFormula);